/**
 * Fuwa Cart - Custom Cart Drawer Plugin for Shopify Craft Theme
 * Version adaptée pour s'intégrer au thème Craft
 */

const FuwaCart = (function () {
    'use strict';

    // État interne
    let cart = null;
    let settings = null;
    let isOpen = false;
    let isUpdating = false;
    let isCheckingGifts = false; // Mutex pour empêcher les race conditions

    // Éléments DOM
    let elements = {};

    /**
     * Initialisation du module
     */
    function init() {
        // Récupérer les settings injectés par Liquid
        settings = window.FuwaCartSettings || {};

        if (!settings.enabled) {
            return;
        }

        // Cache des éléments DOM
        cacheElements();

        // Event listeners
        bindEvents();

        // Charger le panier initial
        fetchCart().then(() => {
            renderRewardsBar();
            renderUpsell();
        });

        // Masquer le cart-drawer original de Craft si présent
        hideCraftCartDrawer();

    }

    /**
     * Masquer le cart-drawer original du thème Craft
     */
    function hideCraftCartDrawer() {
        const craftDrawer = document.querySelector('cart-drawer');
        if (craftDrawer) {
            craftDrawer.style.display = 'none';
        }
    }

    /**
     * Cache les éléments DOM fréquemment utilisés
     */
    function cacheElements() {
        elements = {
            overlay: document.getElementById('fuwa-cart-overlay'),
            drawer: document.getElementById('fuwa-cart-drawer'),
            closeBtn: document.querySelector('.fuwa-cart-close'),
            itemsContainer: document.getElementById('fuwa-cart-items'),
            emptyState: document.getElementById('fuwa-cart-empty'),
            footer: document.getElementById('fuwa-cart-footer'),
            totalEl: document.getElementById('fuwa-cart-total'),
            rewardsBar: document.getElementById('fuwa-rewards-bar'),
            rewardsProgressFill: document.getElementById('fuwa-rewards-progress-fill'),
            rewardsTiers: document.getElementById('fuwa-rewards-tiers'),
            rewardsMessage: document.getElementById('fuwa-rewards-message'),
            upsellContainer: document.getElementById('fuwa-upsell'),
            upsellProducts: document.getElementById('fuwa-upsell-products'),
            upsellTitle: document.getElementById('fuwa-upsell-title'),
            freeGiftNotice: document.getElementById('fuwa-free-gift-notice'),
            rewardsRecap: document.getElementById('fuwa-rewards-recap'),
            giftOffersContainer: document.getElementById('fuwa-gift-offers'),
            giftOffersList: document.getElementById('fuwa-gift-offers-list')
        };
    }

    /**
     * Bindage des événements (intégration robuste Ajax API)
     */
    function bindEvents() {
        // === BOUTON FERMER ===
        if (elements.closeBtn) {
            elements.closeBtn.addEventListener('click', close);
        }

        // === OVERLAY ===
        if (elements.overlay) {
            elements.overlay.addEventListener('click', close);
        }

        // === TOUCHE ESCAPE ===
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && isOpen) {
                close();
            }
        });

        // === BOUTON PANIER DU HEADER ===
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble) {
            cartIconBubble.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                open(cartIconBubble);
            }, true); // Capture phase
        }

        // ============================================================
        // INTERCEPTION ROBUSTE DES FORMULAIRES ADD-TO-CART
        // Utilise la CAPTURE PHASE pour s'exécuter AVANT le thème
        // ============================================================
        document.addEventListener('submit', handleAddToCartForm, true);

        // === INTERCEPTER TOUS LES LIENS VERS /cart ===
        document.addEventListener('click', (e) => {
            const link = e.target.closest('a[href*="/cart"]');
            if (link && !link.href.includes('/checkout') && !link.href.includes('/cart/add')) {
                e.preventDefault();
                e.stopPropagation();
                open();
            }
        }, true); // Capture phase

        // ============================================================
        // INTERCEPTION DES BOUTONS GEMPAGES (gp-product-button)
        // Ces boutons utilisent leur propre système d'ajout au panier
        // ============================================================
        document.addEventListener('click', handleGemPagesButton, true);

        // === S'ABONNER AU PUBSUB SI DISPONIBLE (pour sync avec thème) ===
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                if (event.source === 'fuwa-cart') return;
                if (event.cartData) {
                    cart = event.cartData;
                    renderCart();
                    renderRewardsBar();
                    renderUpsell();
                    updateCartCount();
                }
            });
        }
    }

    /**
     * Gestionnaire des boutons GemPages (gp-product-button, gp-button-atc)
     * Intercepte les clics AVANT le script GemPages
     */
    function handleGemPagesButton(e) {
        // Chercher un bouton GemPages add-to-cart
        const gpButton = e.target.closest('gp-product-button button[name="add"], gp-product-button .gp-button-atc, .gp-button-atc[type="submit"]');
        if (!gpButton) return;

        // Trouver le conteneur gp-product-button parent
        const gpProductButton = gpButton.closest('gp-product-button');
        if (!gpProductButton) return;

        // Bloquer le comportement GemPages
        e.preventDefault();
        e.stopImmediatePropagation();


        // Extraire le variantID depuis l'attribut gp-data
        let variantId = null;
        try {
            const gpData = gpProductButton.getAttribute('gp-data');
            if (gpData) {
                const data = JSON.parse(gpData);
                variantId = data.variantID;
            }
        } catch (err) {
            console.error(error);
        }

        if (!variantId) {
            console.error(error);
            return;
        }

        // État du bouton : loading
        const originalText = gpButton.innerHTML;
        gpButton.setAttribute('data-state', 'loading');
        gpButton.disabled = true;

        // Ajouter au panier via Ajax API
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{
                    id: parseInt(variantId),
                    quantity: 1
                }]
            })
        })
            .then(response => {
                if (!response.ok) throw new Error('Erreur ajout panier');
                return response.json();
            })
            .then(item => {
                return refreshCart().then(() => {
                    open();
                    // Publier l'événement PubSub
                    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fuwa-cart', cartData: cart });
                    }
                });
            })
            .catch(error => {
                console.error(error);
                alert('Erreur lors de l\'ajout au panier. Veuillez réessayer.');
            })
            .finally(() => {
                gpButton.setAttribute('data-state', 'idle');
                gpButton.disabled = false;
            });
    }

    /**
     * Gestionnaire robuste des formulaires add-to-cart
     * S'exécute en CAPTURE PHASE avant le thème
     */
    function handleAddToCartForm(e) {
        const form = e.target.closest('form[action*="/cart/add"]');
        if (!form) return;

        // Bloquer le comportement par défaut du thème
        e.preventDefault();
        e.stopImmediatePropagation();


        // Récupérer les données du formulaire
        const formData = new FormData(form);

        // Désactiver le bouton pendant le chargement
        const submitBtn = form.querySelector('[type="submit"], button[name="add"]');
        const originalText = submitBtn ? submitBtn.innerHTML : '';
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.innerHTML = '<span class="fuwa-loading-spinner"></span>';
        }

        // Ajouter au panier via Ajax API
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Erreur ajout panier');
                }
                return response.json();
            })
            .then(item => {

                // Rafraîchir notre panier et ouvrir le drawer
                return refreshCart().then(() => {
                    open();

                    // Publier l'événement pour synchroniser avec le thème si possible
                    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'fuwa-cart',
                            cartData: cart
                        });
                    }
                });
            })
            .catch(error => {
                console.error(error);
                // Afficher une erreur à l'utilisateur
                alert('Erreur lors de l\'ajout au panier. Veuillez réessayer.');
            })
            .finally(() => {
                // Réactiver le bouton
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.innerHTML = originalText;
                }
            });
    }

    // === FONCTION OPEN (Style Craft) ===
    function open(triggeredBy) {
        if (!elements.drawer) {
            console.error(error);
            return;
        }

        isOpen = true;

        // Classes CSS comme le thème Craft
        elements.drawer.classList.add('animate', 'active', 'is-open');
        if (elements.overlay) elements.overlay.classList.add('is-visible');
        document.body.classList.add('overflow-hidden', 'fuwa-cart-open');

        // Rafraîchir le contenu
        refreshCart();

        // Focus trap (comme Craft)
        if (typeof trapFocus === 'function') {
            trapFocus(elements.drawer, elements.closeBtn);
        }
    }

    // === FONCTION CLOSE (Style Craft) ===
    function close() {
        if (!elements.drawer) return;

        isOpen = false;

        // Retirer les classes
        elements.drawer.classList.remove('active', 'is-open');
        if (elements.overlay) elements.overlay.classList.remove('is-visible');
        document.body.classList.remove('overflow-hidden', 'fuwa-cart-open');

        // Libérer le focus trap (comme Craft)
        if (typeof removeTrapFocus === 'function') {
            removeTrapFocus();
        }
    }

    // === FONCTION TOGGLE ===
    function toggle() {
        isOpen ? close() : open();
    }

    /**
     * Intercepter les appels fetch pour détecter les modifications du panier Craft
     */
    function interceptFetchCalls() {
        const originalFetch = window.fetch;

        window.fetch = function (...args) {
            const url = args[0];

            return originalFetch.apply(this, args).then(response => {
                // Cloner la réponse pour pouvoir la lire
                const clonedResponse = response.clone();

                // Détecter les appels cart
                if (typeof url === 'string' && (
                    url.includes('/cart/add') ||
                    url.includes('/cart/change') ||
                    url.includes('/cart/update')
                )) {
                    // Rafraîchir notre panier après un délai
                    setTimeout(() => {
                        fetchCart().then(() => {
                            renderCart();
                            renderRewardsBar();
                            renderUpsell();
                            checkFreeGift();
                            updateCartCount();
                        });
                    }, 100);
                }

                return response;
            });
        };
    }



    /**
     * Récupérer les données du panier via AJAX
     */
    async function fetchCart() {
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js', {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });

            cart = await response.json();
            return cart;
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    /**
     * Calculer le total du panier SANS les cadeaux gratuits
     * Important pour déterminer si on a atteint un seuil
     */
    function getCartTotalWithoutGifts() {
        if (!cart || !cart.items) return 0;

        let total = 0;
        cart.items.forEach(item => {
            // Exclure les cadeaux ajoutés automatiquement par Fuwa Cart
            if (!item.properties?._fuwa_gift) {
                total += item.final_line_price;
            }
        });

        return total / 100; // Convertir en euros
    }

    /**
     * Ajouter un produit au panier
     */
    async function addItem(variantId, quantity = 1, properties = {}) {
        if (isUpdating) return;
        isUpdating = true;

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: quantity,
                        properties: properties
                    }]
                })
            });

            if (response.ok) {
                await refreshCart();
                open();
            } else {
                const error = await response.json();
                console.error(error);
                showNotification(error.description || 'Erreur lors de l\'ajout', 'error');
            }
        } catch (error) {
            console.error(error);
        } finally {
            isUpdating = false;
        }
    }

    /**
     * Mettre à jour la quantité d'un produit
     */
    async function updateItem(key, quantity) {
        if (isUpdating) return;
        isUpdating = true;

        // Animation de chargement
        const itemEl = document.querySelector(`[data-key="${key}"]`);
        if (itemEl) itemEl.classList.add('is-updating');

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: key,
                    quantity: quantity
                })
            });

            if (response.ok) {
                await refreshCart();
            }
        } catch (error) {
            console.error(error);
        } finally {
            isUpdating = false;
            if (itemEl) itemEl.classList.remove('is-updating');
        }
    }

    /**
     * Supprimer un produit du panier
     */
    async function removeItem(key) {
        await updateItem(key, 0);
    }

    /**
     * Rafraîchir le panier et l'interface
     */
    async function refreshCart() {
        await fetchCart();
        renderCart();
        renderRewardsBar();
        renderRewardsRecap();
        renderUpsell();
        updateCartCount();

        // Vérifier les cadeaux (avec mutex, pas de doublon)
        await checkFreeGift();

        // Re-render après ajout éventuel de cadeaux
        await fetchCart();
        renderCart();
        renderRewardsBar();
        renderRewardsRecap();
        updateCartCount();
    }

    /**
     * Rendu du contenu du panier
     */
    function renderCart() {
        if (!cart || !elements.itemsContainer) return;

        const hasItems = cart.item_count > 0;

        // Toggle états vide/plein
        if (elements.emptyState) {
            elements.emptyState.style.display = hasItems ? 'none' : 'flex';
        }
        if (elements.itemsContainer) {
            elements.itemsContainer.style.display = hasItems ? 'block' : 'none';
        }
        if (elements.footer) {
            elements.footer.style.display = hasItems ? 'block' : 'none';
        }

        if (!hasItems) return;

        // Rendu des items
        let itemsHTML = '';
        cart.items.forEach(item => {
            itemsHTML += renderCartItem(item);
        });
        elements.itemsContainer.innerHTML = itemsHTML;

        // Mise à jour du total
        if (elements.totalEl) {
            elements.totalEl.textContent = formatMoney(cart.total_price);
        }
    }

    /**
     * Rendu d'un item du panier (HTML)
     */
    function renderCartItem(item) {
        // Cadeau = prix à 0€ (la réduction Shopify rend le produit gratuit)
        const isGift = item.final_line_price === 0;
        const imageUrl = item.image ? item.image.replace(/(\.[^.]+)$/, '_150x$1') : '';

        return `
      <div class="fuwa-cart-item" data-key="${item.key}" data-variant-id="${item.variant_id}">
        <div class="fuwa-cart-item-image">
          <a href="${item.url}">
            ${imageUrl
                ? `<img src="${imageUrl}" alt="${escapeHtml(item.title)}" loading="lazy" width="75" height="75">`
                : `<div class="fuwa-cart-item-no-image"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect></svg></div>`
            }
          </a>
          ${isGift ? '<span class="fuwa-cart-item-badge fuwa-gift-badge">CADEAU</span>' : ''}
        </div>
        
        <div class="fuwa-cart-item-info">
          <a href="${item.url}" class="fuwa-cart-item-title">${escapeHtml(item.product_title)}</a>
          ${item.variant_title ? `<p class="fuwa-cart-item-variant">${escapeHtml(item.variant_title)}</p>` : ''}
          <div class="fuwa-cart-item-price">
            ${isGift
                ? '<span class="fuwa-cart-item-price-free">OFFERT</span>'
                : `<span class="fuwa-cart-item-price-current">${formatMoney(item.final_line_price)}</span>`
            }
          </div>
        </div>
        
        <div class="fuwa-cart-item-actions">
          ${isGift
                ? '<span class="fuwa-cart-item-qty-gift">×1</span>'
                : `
              <div class="fuwa-cart-item-qty">
                <button type="button" class="fuwa-qty-btn fuwa-qty-minus" onclick="FuwaCart.updateItem('${item.key}', ${item.quantity - 1})" aria-label="Réduire">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>
                <span class="fuwa-qty-value">${item.quantity}</span>
                <button type="button" class="fuwa-qty-btn fuwa-qty-plus" onclick="FuwaCart.updateItem('${item.key}', ${item.quantity + 1})" aria-label="Augmenter">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>
              </div>
              <button type="button" class="fuwa-cart-item-remove" onclick="FuwaCart.removeItem('${item.key}')" aria-label="Supprimer">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
              </button>
            `
            }
        </div>
      </div>
    `;
    }

    /**
     * Rendu de la barre de récompenses
     */
    function renderRewardsBar() {
        if (!elements.rewardsBar || !cart) return;

        // IMPORTANT: Calculer le total SANS les cadeaux pour éviter le paradoxe
        const cartTotal = getCartTotalForThreshold();
        const tiers = getActiveTiers();

        if (tiers.length === 0) {
            elements.rewardsBar.style.display = 'none';
            return;
        }

        elements.rewardsBar.style.display = 'flex';

        // Calculer le seuil max pour les messages
        const maxThreshold = Math.max(...tiers.map(t => t.threshold));
        const tierCount = tiers.length;

        // === BARRE DE PROGRESSION FICTIVE ===
        // La progression suit les positions visuelles des paliers (33%, 66%, 100% pour 3 paliers)
        // au lieu du ratio réel (cartTotal/maxThreshold)

        let progressPercent = 0;

        // Trouver entre quels paliers on se situe
        for (let i = 0; i < tiers.length; i++) {
            const tierPosition = ((i + 1) / tierCount) * 100; // Position visuelle (33%, 66%, 100%)
            const prevTierPosition = i === 0 ? 0 : (i / tierCount) * 100;
            const tierThreshold = tiers[i].threshold;
            const prevThreshold = i === 0 ? 0 : tiers[i - 1].threshold;

            if (cartTotal < tierThreshold) {
                // On est entre le palier précédent et ce palier
                // Calculer la progression entre les deux positions visuelles
                const progressInSegment = (cartTotal - prevThreshold) / (tierThreshold - prevThreshold);
                progressPercent = prevTierPosition + (progressInSegment * (tierPosition - prevTierPosition));
                break;
            } else {
                // On a dépassé ce palier
                progressPercent = tierPosition;
            }
        }

        // S'assurer qu'on ne dépasse pas 100%
        progressPercent = Math.min(100, Math.max(0, progressPercent));

        // Mettre à jour la largeur du fill avec un petit délai pour l'animation
        if (elements.rewardsProgressFill) {
            // Réinitialiser à 0 si c'est le premier rendu pour forcer l'animation
            if (elements.rewardsProgressFill.style.width === '0%' || elements.rewardsProgressFill.style.width === '') {
                elements.rewardsProgressFill.style.width = '0%';
                // Forcer un reflow pour que la transition s'anime depuis 0
                elements.rewardsProgressFill.offsetHeight;
            }

            // Appliquer la nouvelle largeur (l'animation CSS transition: width 0.5s fera le reste)
            setTimeout(() => {
                elements.rewardsProgressFill.style.width = `${progressPercent}%`;
            }, 50);
        }

        // Message dynamique (au-dessus de la barre)
        if (elements.rewardsMessage) {
            const message = getRewardsMessage(cartTotal, tiers);
            elements.rewardsMessage.innerHTML = message;
        }

        // Rendu des marqueurs de paliers avec positionnement équitable
        if (elements.rewardsTiers) {
            let tiersHTML = '';
            const tierCount = tiers.length;

            tiers.forEach((tier, index) => {
                // Position: le dernier palier (max) est à 100%, les autres sont répartis équitablement
                // Si 3 paliers: positions à 33%, 66%, 100%
                const position = ((index + 1) / tierCount) * 100;
                const isUnlocked = cartTotal >= tier.threshold;

                // Texte du tooltip
                const tierTypeLabel = getTierTypeLabel(tier.type);
                const statusText = isUnlocked ? '✓ Débloqué !' : `À partir de ${tier.threshold}€`;

                tiersHTML += `
                    <div class="fuwa-rewards-tier ${isUnlocked ? 'is-unlocked' : ''}" 
                         style="left: ${position}%"
                         tabindex="0"
                         role="button"
                         aria-label="${tierTypeLabel} à ${tier.threshold}€">
                        <span class="fuwa-rewards-tier-icon">${tier.icon}</span>
                        <span class="fuwa-rewards-tier-label">${tier.threshold}€</span>
                        <div class="fuwa-rewards-tier-tooltip">
                            ${tierTypeLabel}
                            <span class="fuwa-tier-status">${statusText}</span>
                        </div>
                    </div>
                `;
            });
            elements.rewardsTiers.innerHTML = tiersHTML;
        }
    }

    /**
     * Obtenir le label du type de palier
     */
    function getTierTypeLabel(type) {
        switch (type) {
            case 'gift': return '🎁 Cadeau offert';
            case 'shipping': return '🚚 Livraison gratuite';
            case 'discount': return '💰 Réduction';
            default: return '✨ Récompense';
        }
    }

    /**
     * Afficher le récapitulatif des paliers débloqués
     * Affiche la liste des avantages obtenus (livraison gratuite, cadeaux, etc.)
     */
    function renderRewardsRecap() {
        if (!elements.rewardsRecap || !cart) return;

        const cartTotal = getCartTotalForThreshold();
        const tiers = getActiveTiers();

        // Trouver les paliers débloqués
        const unlockedTiers = tiers.filter(tier => cartTotal >= tier.threshold);

        if (unlockedTiers.length === 0) {
            elements.rewardsRecap.style.display = 'none';
            return;
        }

        // Générer le HTML du récap
        let recapHTML = '';
        unlockedTiers.forEach(tier => {
            const label = tier.messageAfter || getTierTypeLabel(tier.type);
            recapHTML += `
                <div class="fuwa-recap-item">
                    <span class="fuwa-recap-icon">${tier.icon || '✓'}</span>
                    <span class="fuwa-recap-label">${label}</span>
                </div>
            `;
        });

        elements.rewardsRecap.innerHTML = recapHTML;
        elements.rewardsRecap.style.display = 'block';
    }

    /**
     * Vérifie si un variant_id correspond à un cadeau configuré
     */
    function isGiftVariant(variantId) {
        const tiers = getActiveTiers();
        return tiers.some(tier =>
            tier.type === 'gift' && tier.giftVariantId == variantId
        );
    }

    /**
     * Obtenir les paliers actifs (depuis le nouveau format dynamique)
     */
    function getActiveTiers() {
        // Le nouveau format utilise settings.tiers qui est déjà trié
        if (settings.tiers && Array.isArray(settings.tiers)) {
            return settings.tiers.filter(tier => tier.threshold > 0);
        }

        // Fallback vers l'ancien format si nécessaire
        const tiers = [];

        if (settings.tier1?.enabled) {
            tiers.push({
                type: 'gift',
                icon: '🎁',
                threshold: settings.tier1.threshold,
                messageBefore: settings.tier1.messageBefore,
                messageAfter: settings.tier1.messageAfter,
                giftVariantId: settings.giftProductData?.variantId
            });
        }

        if (settings.tier2?.enabled) {
            tiers.push({
                type: 'discount',
                icon: '💰',
                threshold: settings.tier2.threshold,
                messageBefore: settings.tier2.messageBefore?.replace('{{discount}}', settings.tier2.discountPercent),
                messageAfter: settings.tier2.messageAfter?.replace('{{discount}}', settings.tier2.discountPercent)
            });
        }

        if (settings.tier3?.enabled) {
            tiers.push({
                type: 'shipping',
                icon: '🚚',
                threshold: settings.tier3.threshold,
                messageBefore: settings.tier3.messageBefore,
                messageAfter: settings.tier3.messageAfter
            });
        }

        return tiers.sort((a, b) => a.threshold - b.threshold);
    }

    /**
     * Calculer le total du panier pour le calcul des seuils
     * Exclut la valeur d'UNE unité des cadeaux SEULEMENT s'ils ne sont pas déjà gratuits
     * (Shopify peut déjà avoir appliqué la réduction)
     */
    function getCartTotalForThreshold() {
        if (!cart || !cart.items) return 0;

        // Total brut du panier (Shopify a peut-être déjà appliqué des réductions)
        let total = cart.total_price / 100;

        // Récupérer tous les variant IDs des cadeaux configurés
        const tiers = getActiveTiers();
        const giftVariantIds = tiers
            .filter(tier => tier.giftVariantId)
            .map(tier => ({
                variantId: tier.giftVariantId,
                threshold: tier.threshold
            }));

        // Pour chaque cadeau configuré
        for (const gift of giftVariantIds) {
            // Chercher ce produit dans le panier
            const itemInCart = cart.items.find(item =>
                item.variant_id == gift.variantId
            );

            if (itemInCart) {
                // Vérifier si le cadeau est DÉJÀ gratuit (réduction Shopify appliquée)
                const isAlreadyFree = itemInCart.final_line_price === 0;

                if (!isAlreadyFree) {
                    // Le cadeau n'est PAS encore gratuit, on soustrait son prix
                    // pour le calcul du seuil (éviter le paradoxe)
                    const unitPrice = itemInCart.original_price / 100;
                    total -= unitPrice;
                }
                // Si déjà gratuit, on ne soustrait rien car total_price ne l'inclut déjà pas
            }
        }

        // Ne pas retourner de valeur négative
        return Math.max(0, total);
    }

    /**
     * Générer le message de récompense approprié
     */
    function getRewardsMessage(cartTotal, tiers) {
        // Trouver le prochain palier non atteint
        const nextTier = tiers.find(t => cartTotal < t.threshold);

        if (!nextTier) {
            // Tous les paliers atteints
            const lastTier = tiers[tiers.length - 1];
            return lastTier?.messageAfter || '🎉 Tous les avantages débloqués !';
        }

        const remaining = (nextTier.threshold - cartTotal).toFixed(2).replace('.', ',');
        let message = nextTier.messageBefore || `Plus que ${remaining}€ pour débloquer ${nextTier.icon}`;

        // Remplacer les variables dans le message
        message = message.replace('{{remaining}}', remaining);
        if (nextTier.discount) {
            message = message.replace('{{discount}}', nextTier.discount);
        }

        return message;
    }

    /**
     * Afficher les cadeaux disponibles (version RGPD - Opt-in)
     * Ne les ajoute PAS automatiquement, affiche une liste avec boutons
     */
    function renderGiftOffers() {
        if (!elements.giftOffersContainer || !elements.giftOffersList || !cart) {
            return;
        }

        const cartTotal = getCartTotalForThreshold();
        const tiers = getActiveTiers();

        // Trouver les cadeaux débloqués mais pas encore dans le panier
        const availableGifts = [];

        for (const tier of tiers) {
            if (!tier.giftVariantId || !tier.giftProductData) continue;

            const thresholdReached = cartTotal >= tier.threshold;
            const giftInCart = cart.items.find(item =>
                item.variant_id == tier.giftVariantId
            );

            // Cadeau disponible = seuil atteint ET pas déjà dans le panier
            if (thresholdReached && !giftInCart) {
                availableGifts.push({
                    variantId: tier.giftVariantId,
                    title: tier.giftProductData.title || 'Cadeau gratuit',
                    image: tier.giftProductData.image || '',
                    threshold: tier.threshold,
                    icon: tier.icon || '🎁'
                });
            }
        }

        // Si aucun cadeau disponible, masquer la section et afficher les upsells
        if (availableGifts.length === 0) {
            elements.giftOffersContainer.style.display = 'none';
            // Réafficher les upsells
            if (elements.upsellContainer) {
                elements.upsellContainer.style.display = 'block';
            }
            return;
        }

        // Générer le HTML des cadeaux disponibles
        let html = '';
        availableGifts.forEach(gift => {
            html += `
                <div class="fuwa-gift-offer-item">
                    ${gift.image ? `<img src="${gift.image}" alt="${gift.title}" class="fuwa-gift-offer-img">` : ''}
                    <div class="fuwa-gift-offer-info">
                        <span class="fuwa-gift-offer-name">${gift.title}</span>
                        <span class="fuwa-gift-offer-badge">OFFERT</span>
                    </div>
                    <button class="fuwa-gift-offer-btn" 
                            data-variant-id="${gift.variantId}"
                            onclick="FuwaCart.claimGift(${gift.variantId})">
                        Ajouter
                    </button>
                </div>
            `;
        });

        elements.giftOffersList.innerHTML = html;
        elements.giftOffersContainer.style.display = 'block';

        // Masquer les upsells quand les cadeaux sont affichés
        if (elements.upsellContainer) {
            elements.upsellContainer.style.display = 'none';
        }
    }

    /**
     * Réclamer un cadeau (action utilisateur - conforme RGPD)
     * Appelé quand l'utilisateur clique sur "Ajouter"
     */
    async function claimGift(variantId) {

        // Trouver le bouton et le désactiver
        const btn = document.querySelector(`[data-variant-id="${variantId}"]`);
        if (btn) {
            btn.disabled = true;
            btn.textContent = '...';
        }

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1
                    }]
                })
            });

            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }


            // Afficher la notification de succès
            showGiftNotification();

            // Rafraîchir le panier
            await refreshCart();

        } catch (error) {
            console.error(error);
            if (btn) {
                btn.disabled = false;
                btn.textContent = 'Réessayer';
            }
        }
    }

    /**
     * Vérifier les cadeaux : afficher les offres ET supprimer ceux qui ne sont plus valides
     */
    async function checkFreeGift() {
        // Afficher les offres disponibles (opt-in RGPD)
        renderGiftOffers();

        // Vérifier et supprimer les cadeaux dont le seuil n'est plus atteint
        await removeInvalidGifts();
    }

    /**
     * Supprimer les cadeaux gratuits dont le seuil n'est plus atteint
     */
    async function removeInvalidGifts() {
        if (!cart || !cart.items) return;

        const tiers = getActiveTiers();
        const giftsToRemove = [];

        // Pour chaque palier avec un cadeau configuré
        for (const tier of tiers) {
            if (!tier.giftVariantId) continue;

            // Chercher ce cadeau dans le panier
            const giftInCart = cart.items.find(item =>
                item.variant_id == tier.giftVariantId &&
                item.final_line_price === 0 // Seulement les cadeaux gratuits
            );

            if (giftInCart) {
                // Calculer le total SANS ce cadeau pour vérifier le seuil
                const totalWithoutThisGift = calculateTotalWithoutGift(tier.giftVariantId);

                // Si le total sans ce cadeau est sous le seuil, le cadeau doit être retiré
                if (totalWithoutThisGift < tier.threshold) {
                    giftsToRemove.push(giftInCart.key);
                }
            }
        }

        // Supprimer les cadeaux invalides directement via API 
        // (contourne le verrou isUpdating de updateItem)
        for (const key of giftsToRemove) {
            try {
                await fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: key, quantity: 0 })
                });
            } catch (error) {
                console.error(error);
            }
        }

        // Si on a supprimé des cadeaux, rafraîchir l'affichage
        if (giftsToRemove.length > 0) {
            await fetchCart();
            renderCart();
            renderRewardsBar();
            renderGiftOffers();
            updateCartCount();
        }
    }

    /**
     * Calculer le total du panier sans un cadeau spécifique
     */
    function calculateTotalWithoutGift(giftVariantId) {
        if (!cart || !cart.items) return 0;

        let total = 0;
        for (const item of cart.items) {
            // Exclure le cadeau spécifié
            if (item.variant_id == giftVariantId && item.final_line_price === 0) {
                continue;
            }
            total += item.final_line_price;
        }
        return total / 100;
    }

    /**
     * Afficher la notification de cadeau
     */
    function showGiftNotification() {
        if (elements.freeGiftNotice) {
            elements.freeGiftNotice.style.display = 'flex';
            setTimeout(() => {
                elements.freeGiftNotice.style.display = 'none';
            }, 4000);
        }
    }

    /**
     * Rendu de la zone upsell
     */
    function renderUpsell() {
        if (!settings.upsell?.enabled || !elements.upsellContainer) {
            if (elements.upsellContainer) elements.upsellContainer.style.display = 'none';
            return;
        }

        const upsellProducts = settings.upsellProductsData || [];

        // Filtrer les produits déjà dans le panier
        const cartProductIds = cart?.items.map(item => item.product_id) || [];
        const availableProducts = upsellProducts.filter(p => !cartProductIds.includes(p.id));

        if (availableProducts.length === 0) {
            elements.upsellContainer.style.display = 'none';
            return;
        }

        elements.upsellContainer.style.display = 'block';

        // Titre
        if (elements.upsellTitle && settings.upsell.title) {
            elements.upsellTitle.textContent = settings.upsell.title;
        }

        // Produits
        if (elements.upsellProducts) {
            let productsHTML = '';
            availableProducts.forEach(product => {
                productsHTML += `
          <div class="fuwa-upsell-product">
            <a href="${product.url}" class="fuwa-upsell-product-image">
              <img src="${product.image}" alt="${escapeHtml(product.title)}" loading="lazy">
            </a>
            <div class="fuwa-upsell-product-info">
              <a href="${product.url}" class="fuwa-upsell-product-title">${escapeHtml(product.title)}</a>
              <span class="fuwa-upsell-product-price">${product.priceFormatted}</span>
            </div>
            <button type="button" class="fuwa-upsell-add-btn" onclick="FuwaCart.addItem(${product.variantId})">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              Ajouter
            </button>
          </div>
        `;
            });
            elements.upsellProducts.innerHTML = productsHTML;
        }
    }

    /**
     * Mettre à jour le compteur de panier dans le header
     */
    function updateCartCount() {
        const count = cart?.item_count || 0;

        // Notre compteur
        const fuwaCountElements = document.querySelectorAll('[data-fuwa-cart-count]');
        fuwaCountElements.forEach(el => {
            el.textContent = count;
            el.style.display = count > 0 ? '' : 'none';
        });

        // Compteur Craft (cart-count-bubble)
        const craftBubble = document.querySelector('.cart-count-bubble');
        if (craftBubble) {
            if (count > 0) {
                craftBubble.innerHTML = `<span aria-hidden="true">${count}</span>`;
                craftBubble.style.display = '';
            } else {
                craftBubble.style.display = 'none';
            }
        }
    }

    /**
     * Afficher une notification
     */
    function showNotification(message, type = 'info') {
    }

    // ==================
    // Fonctions utilitaires
    // ==================

    function formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return `${amount} €`.replace('.', ',');
    }

    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    // ==================
    // API Publique
    // ==================

    return {
        init,
        open,
        close,
        toggle,
        addItem,
        updateItem,
        removeItem,
        refreshCart,
        claimGift,
        getCart: () => cart,
        getSettings: () => settings
    };

})();

// Auto-initialisation au chargement du DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', FuwaCart.init);
} else {
    FuwaCart.init();
}
